import { render, staticRenderFns } from "./workOrderDetail.vue?vue&type=template&id=663f016a&scoped=true"
import script from "./workOrderDetail.vue?vue&type=script&lang=js"
export * from "./workOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./workOrderDetail.vue?vue&type=style&index=0&id=663f016a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f016a",
  null
  
)

export default component.exports